import React from 'react';

const SessionClearButton = ({clearSession}) => {
  return (
    <button onClick={clearSession} className="uk-button uk-button-default tm-button-default">clear session</button>
  );
};

export default SessionClearButton;
